import type { AutomationConfig, AutomationId } from "../types";

export interface AutomationFormValues {
  messageTemplateId: string;
}

export function buildAutomationFormDefaultValues(params: {
  automationId: AutomationId;
  defaultTemplateId?: string;
}): AutomationFormValues {
  const { defaultTemplateId = "" } = params;

  return {
    messageTemplateId: defaultTemplateId,
  };
}

export function toAutomationFormValues(
  config: AutomationConfig,
): AutomationFormValues {
  return {
    messageTemplateId: config.messageTemplateId,
  };
}

export function toAutomationConfig(params: {
  automationId: AutomationId;
  values: AutomationFormValues;
}): AutomationConfig {
  const { automationId, values } = params;

  return {
    automationId,
    messageTemplateId: values.messageTemplateId,
  };
}
